(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ankor-video-carousel]').forEach(function (root) {
    const viewport = root.querySelector('[data-ankor-vc-viewport]');
    const track = root.querySelector('[data-ankor-vc-track]');
    const prev = root.querySelector('[data-ankor-vc-prev]');
    const next = root.querySelector('[data-ankor-vc-next]');
    if (!track || !viewport) return;

    const slides = Array.from(track.querySelectorAll('.ankor-video-carousel__slide'));
    if (!slides.length) return;
    const uniqueCount = parseInt(track.dataset.uniqueCount, 10) || slides.length;

    let activeIndex = uniqueCount; // começa no 1º slide do conjunto do meio (real)
    let position = 0;
    const GAP = 14;

    // largura do slide/viewport só muda no breakpoint (media query), não por
    // slide ativo - cacheia em vez de ler offsetWidth/clientWidth toda hora,
    // que força reflow síncrono se rodar logo depois de qualquer mudança de
    // classe/atributo (como o toggle de is-active em setActive)
    let cachedSlideWidth = slides[0].offsetWidth;
    let cachedViewportWidth = viewport.clientWidth;

    function slideWidth() {
      return cachedSlideWidth;
    }
    function step() {
      return slideWidth() + GAP;
    }
    function targetPositionForIndex(index) {
      const offsetWithinTrack = index * step();
      return -(offsetWithinTrack + slideWidth() / 2 - cachedViewportWidth / 2);
    }
    function applyTransform(px, animate) {
      track.style.transition = animate ? 'transform 0.35s cubic-bezier(.2,.8,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
    }

    // só o poster (imagem leve) carrega pros slides perto do ativo - o vídeo
    // em si só baixa quando o cliente toca no play (ver loadAndPlay), pra não
    // gastar dados/CPU com vídeo que ninguém pediu pra ver
    function updatePosters() {
      slides.forEach(function (slide, i) {
        const video = slide.querySelector('video');
        if (!video) return;
        const near = Math.abs(i - activeIndex) <= 1;
        if (near && !video.getAttribute('poster') && video.dataset.poster) {
          video.setAttribute('poster', video.dataset.poster);
        }
      });
    }

    function unloadVideo(slide) {
      const video = slide.querySelector('video');
      if (!video) return;
      slide.classList.remove('is-playing');
      if (!video.paused) video.pause();
      if (video.getAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
    }

    function loadAndPlay(slide) {
      const video = slide.querySelector('video');
      if (!video) return;
      if (slide.classList.contains('is-playing')) {
        video.pause();
        slide.classList.remove('is-playing');
        return;
      }
      if (!video.getAttribute('src') && video.dataset.src) {
        video.setAttribute('src', video.dataset.src);
        video.preload = 'auto';
        video.load();
      }
      slide.classList.add('is-playing');
      playWhenReady(video);
    }

    // chamar play() colado com load()/troca de src pode falhar silenciosamente
    // (o navegador ainda está processando a nova fonte) - se ainda não tem
    // dado suficiente, espera o evento certo antes de mandar tocar
    function playWhenReady(video) {
      if (video.readyState >= 3) {
        video.play().catch(function () {});
        return;
      }
      const onReady = function () {
        video.removeEventListener('canplay', onReady);
        video.play().catch(function () {});
      };
      video.addEventListener('canplay', onReady);
    }

    function setActive(index, animate) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      activeIndex = index;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      position = targetPositionForIndex(index);
      applyTransform(position, animate !== false);

      // navegar pra longe de um vídeo tocando pausa e descarrega ele - tocar
      // é sempre uma ação explícita do cliente (botão de play), nunca automático
      slides.forEach(function (s, i) {
        if (i !== index) unloadVideo(s);
      });
      updatePosters();

      if (animate !== false) {
        clearTimeout(wrapTimer);
        wrapTimer = setTimeout(wrapIfNeeded, 380);
      }
    }

    // se o índice ativo cair perto demais de uma ponta do conjunto duplicado,
    // pula (sem animação, invisível) pro equivalente no conjunto do meio -
    // como os 3 conjuntos são idênticos, o pulo não se percebe
    let wrapTimer = null;
    function wrapIfNeeded() {
      if (activeIndex < uniqueCount * 0.5) {
        setActive(activeIndex + uniqueCount, false);
      } else if (activeIndex >= uniqueCount * 2.5) {
        setActive(activeIndex - uniqueCount, false);
      }
    }

    // arrasto manual via pointer events - sem scroll nativo, sem scroll-snap.
    // Só assume o gesto quando o movimento é claramente mais horizontal que
    // vertical (senão intercepta sem querer um scroll vertical de página que
    // só tremeu um pouco no eixo X, o que é normal no toque humano)
    let dragging = false;
    let axisLocked = null; // 'x' | 'y' | null (ainda decidindo)
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartPosition = 0;
    let dragDistance = 0;

    track.addEventListener(
      'pointerdown',
      function (e) {
        dragDistance = 0;
        // toque começou no botão de play: deixa o botão cuidar do próprio
        // clique, sem entrar no sistema de arrasto (senão o tremor natural
        // do dedo ao tocar passa dos 5px e o clique é descartado como
        // "foi arrasto", e o vídeo nunca toca)
        if (e.target.closest('[data-ankor-vc-play]')) return;
        dragging = true;
        axisLocked = null;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragStartPosition = position;
        track.setPointerCapture(e.pointerId);
      },
      { passive: false }
    );

    track.addEventListener(
      'pointermove',
      function (e) {
        if (!dragging) return;
        const deltaX = e.clientX - dragStartX;
        const deltaY = e.clientY - dragStartY;

        if (axisLocked === null) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return; // ainda não moveu o suficiente pra decidir
          axisLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          if (axisLocked === 'x') track.style.transition = 'none';
        }

        if (axisLocked === 'y') return; // é scroll vertical de página, deixa o navegador cuidar

        if (e.cancelable) e.preventDefault();
        dragDistance = Math.abs(deltaX);
        position = dragStartPosition + deltaX;
        track.style.transform = 'translate3d(' + position + 'px, 0, 0)';
      },
      { passive: false }
    );

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      let closestIndex = activeIndex;
      let closestDist = Infinity;
      slides.forEach(function (_, i) {
        const dist = Math.abs(targetPositionForIndex(i) - position);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      setActive(closestIndex, true);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // evita que um arrasto pequeno dispare o clique do link do produto por baixo,
    // e trata o toque no botão de play (só funciona no slide central)
    track.addEventListener(
      'click',
      function (e) {
        if (dragDistance > 5) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        const playBtn = e.target.closest('[data-ankor-vc-play]');
        if (!playBtn) return;
        const slide = playBtn.closest('.ankor-video-carousel__slide');
        if (!slide || slides.indexOf(slide) !== activeIndex) return;
        e.preventDefault();
        loadAndPlay(slide);
      },
      true
    );

    if (prev) prev.addEventListener('click', function () { setActive(activeIndex - 1, true); });
    if (next) next.addEventListener('click', function () { setActive(activeIndex + 1, true); });

    window.addEventListener('resize', function () {
      cachedSlideWidth = slides[0].offsetWidth;
      cachedViewportWidth = viewport.clientWidth;
      setActive(activeIndex, false);
    });

    setActive(uniqueCount, false);
  });

  } catch(e) { console.error(e); }
})();
})();
